export const DEFAULT_APPLICATION_FORM_TITLE = "Staff Application";

export const DEFAULT_APPLICATION_MESSAGE = `Thank you for your interest in helping keep the server safe and welcoming.

Tap **Start Application** below when you're ready. You'll answer a few questions about your experience and how you'd handle common moderation scenarios.

Please be honest and thoughtful. Staff will review your responses.`;

export const DEFAULT_APPLICATION_FIELDS = [
  {
    id: "discord_username",
    label: "Discord Username",
    placeholder: "Your Discord handle",
    required: true,
    style: "short",
  },
  {
    id: "timezone",
    label: "Timezone / Region",
    placeholder: "e.g. EST, Europe",
    required: true,
    style: "short",
  },
  {
    id: "age",
    label: "Age (13+ per Discord TOS)",
    placeholder: "Your age",
    required: true,
    style: "short",
  },
  {
    id: "activity",
    label: "How active can you be?",
    placeholder: "Daily/weekly availability on the server",
    required: true,
    style: "paragraph",
  },
  {
    id: "experience",
    label: "Prior moderation experience?",
    placeholder: "Previous roles or servers, or none",
    required: true,
    style: "paragraph",
  },
  {
    id: "skills",
    label: "Skills / qualities for staff?",
    placeholder: "What makes you a good fit?",
    required: true,
    style: "paragraph",
  },
  {
    id: "tools",
    label: "Familiar moderation bots/tools?",
    placeholder: "Bots, automod, etc.",
    required: true,
    style: "paragraph",
  },
  {
    id: "scenario_argument",
    label: "Scenario: heated argument",
    placeholder: "Two members escalating in public. Your response?",
    required: true,
    style: "paragraph",
  },
  {
    id: "scenario_rules",
    label: "Scenario: minor rule break",
    placeholder: "They claim they didn't know. How do you handle it?",
    required: true,
    style: "paragraph",
  },
  {
    id: "scenario_bias",
    label: "Scenario: friend breaks rules",
    placeholder: "How do you handle bias / conflict of interest?",
    required: true,
    style: "paragraph",
  },
  {
    id: "why_staff",
    label: "Why join our staff team?",
    placeholder: "Why this server specifically?",
    required: true,
    style: "paragraph",
  },
  {
    id: "extra",
    label: "Anything else? (optional)",
    placeholder: "Anything else we should know",
    required: false,
    style: "paragraph",
  },
];
